export default "__VITE_PUBLIC_ASSET__ede7ab9f__"